var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetherlands32X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "48px",
    viewBox: "0 0 71 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "netherlands-3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-493.000000, -192.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.000000, 70.000000)",
    fillRule: "nonzero",
    id: "netherlands-3"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(423.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mozambique-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Equatorial_Guinea-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.39,7.21 L0.39,16.21 L70.39,16.21 L70.39,7.21 C70.39,3.54282926 67.4171707,0.57 63.75,0.57 L7,0.57 C3.34455042,0.586515754 0.38996269,3.55451311 0.39,7.21 Z",
    id: "Shape",
    fill: "#ED5565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "0.39 31.91 70.39 31.91 70.39 16.24 0.39 16.24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.39,40.92 C0.39,44.5871707 3.36282926,47.56 7.03,47.56 L63.75,47.56 C67.4171707,47.56 70.39,44.5871707 70.39,40.92 L70.39,31.92 L0.39,31.92 L0.39,40.92 Z",
    id: "Shape",
    fill: "#4A89DC"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetherlands32X);
export default __webpack_public_path__ + "static/media/netherlands-3@2x.3e9d10da5e4d0c45b8270aa23381c640.svg";
export { ForwardRef as ReactComponent };